import { Component, OnInit, OnDestroy } from '@angular/core';
import { MenuService } from '../menu.service';

declare var jQuery: any;
declare var init: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  constructor(public menuCtrl: MenuService) { }

  ngOnInit() {
    init();
    let vids = document.getElementsByTagName('video');
    for(let i = 0; i < vids.length; i++) {
      vids[i].muted=true;
    }
  }

  ngOnDestroy() {
    // this.menuCtrl.pageTransOut();
  }

}
